import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Logo, Btn } from './UI';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/plans', label: 'Plans' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      background: scrolled ? 'rgba(8,8,8,0.95)' : 'rgba(8,8,8,0.7)',
      backdropFilter: 'blur(20px)',
      borderBottom: '1px solid var(--border)',
      padding: scrolled ? '10px 0' : '14px 0',
      transition: 'all 0.3s'
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Link to="/"><Logo size={36} /></Link>

        {/* Desktop Nav */}
        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          {navLinks.map(link => (
            <Link key={link.path} to={link.path} style={{
              padding: '8px 16px', borderRadius: 8, fontSize: 14,
              color: location.pathname === link.path ? 'var(--text)' : 'var(--text-muted)',
              background: location.pathname === link.path ? 'var(--bg-card)' : 'transparent',
              transition: 'all 0.2s', textDecoration: 'none', fontWeight: location.pathname === link.path ? 500 : 400
            }}>{link.label}</Link>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <Link to="/login"><Btn variant="outline" size="sm">Login</Btn></Link>
          <Link to="/register"><Btn size="sm">Get Started</Btn></Link>
        </div>
      </div>
    </nav>
  );
}
